import React from "react";

const Loading = () => {
  return (
    <>
      <div style={{display:"flex", justifyContent:"center", alignItems:"center"}} className="container">
        <div className="i-loader-inf-horizontal-container">
          <div className="i-loader-inf-horizontal"></div>
          <div className="pt-8px">
            <span>Creating Group...</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loading;
